import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApisService } from '@core/services/apis.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-employee-details',
  templateUrl: './employee-details.component.html',
  styleUrls: ['./employee-details.component.scss']
})
export class EmployeeDetailsComponent implements OnInit {

    productId: string | null = null;
  employee: any = {
    name: '',
    email: '',
    phone: '',
    password: '',
    job_title_id: ''
  };

   employeeId: string | null = null;
  currentLang: string;

constructor(
    private route: ActivatedRoute,
    private router: Router,
    private apiService: ApisService,
    private toastr: ToastrService
  ) {}
    ngOnInit(): void {
    this.currentLang = localStorage.getItem('currentLang') || 'ar';

    // get product id from route
   this.employeeId = this.route.snapshot.paramMap.get('id');
    if (this.employeeId) {
      this.loadEmployee(this.employeeId);
    }


        
  }

getInvestorStatusClass(status: string): string {
    if (!status) return 'inactive';
    
    const statusMap: { [key: string]: string } = {
        'active': 'active',
        'نشط': 'active',
        'مكتمل': 'completed',
        'completed': 'completed',
        'معلق': 'pending',
        'pending': 'pending',
        'غير نشط': 'inactive',
        'inactive': 'inactive',
        'غيرنشط': 'inactive'
    };
    
    return statusMap[status.toLowerCase()] || 'inactive';
}
viewInvestorDetails(investorId: number): void {
    // التنقل إلى صفحة تفاصيل المستثمر
    this.router.navigate(['/investors-details', investorId]);
    // أو فتح modal مع التفاصيل
    // this.openInvestorModal(investorId);
}
addInvestor(){
 this.router.navigate(['/add-investors']);

}
  
  loadEmployee(id: string): void {
    this.apiService.getEmployeeById(id).subscribe({
      next: (res: any) => {
        this.employee = res?.data || this.employee;
      },
      error: (err) => {
        console.error('Failed to load employee:', err);
        this.toastr.error('Failed to load employee details');
      }
    });
  }

}
